import React from 'react'
import { Typography, Box, Link, Container } from '@material-ui/core'
import { useGetOrganization } from 'hooks/useGetOrganization'

const ApplicationNote: React.FC = () => {
  const { organization, subDomain } = useGetOrganization()
  const organizationName = organization?.whiteLabel ? organization?.name || '' : 'EXEC'
  const settingsKey = subDomain?.includes('test') ? 'draftSettings' : 'publishedSettings'
  const contactEmail =
    (organization?.whiteLabel && organization?.[settingsKey]?.ContactApplication?.PointOfContactEmail) ||
    'concierge@exec.vip'

  return (
    <Container maxWidth='md'>
      <Box mt={4}>
        <Typography variant='body2'>
          <Typography component='span' color='primary'>
            *
          </Typography>
          This form is for new member applications. If you have already been provided access to {organizationName}, you
          do not need to complete this form. If you are trying to access your existing {organizationName} account,
          please contact{' '}
          <Link color='primary' href={`mailto:${contactEmail}`}>
            {contactEmail}
          </Link>{' '}
          or follow the activation instructions provided to you.
        </Typography>
      </Box>
    </Container>
  )
}

export default ApplicationNote
